import React from "react";
import isScript from "../../hooks/isScript";
import MailForm from "../mailForm/mailForm";
import { useTranslation } from "react-i18next";

const AlliancePage = () => {
  isScript();

  const { t } = useTranslation("alliance");

  return (
    <>
      <main className="main alliance">
        <section className="banner-main">
          <div className="inner">
            <div>
              <img
                className="logo fade-up"
                src="./assets/logo/logo_bk.png"
                alt="Ready Play Logo"
              />
              <h2 className="sub-tit fade-up">
                {t("banner.mainTit_01")}
                <br />
                {t("banner.mainTit_02")}
              </h2>
            </div>
            <div className="wh100 fade-up">
              <span className="tooltip bounce">
                <p>
                  <ion-icon name="game-controller"></ion-icon>{" "}
                  {t("banner.toolTip_01")}
                </p>
                <p className="mb">{t("banner.toolTip_02")}</p>
              </span>
              <div className="buttons">
                {/* <a href="#" className="btn-main">
                  {t("banner.tour")}
                </a> */}
                <a href="#contact" className="btn-main">
                  {t("banner.partership")}
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="v-space container">
          <div className="inner clearfix">
            <div className="title">
              <h2 className="main-tit .md fade-up">
                <em>{t("space.mainTit_01")}</em>
                <br />
                {t("space.mainTit_02")}
              </h2>
              <h3 className="sub-txt fade-up">
                {t("space.subTxt_01")}
                <br />
                {t("space.subTxt_02")}
              </h3>
            </div>
            <div className="swiper-buttons">
              <div className="btn-prev-vsp">
                <ion-icon name="chevron-back-outline"></ion-icon>
              </div>
              <div className="pagination-vsp"></div>
              <div className="btn-next-vsp">
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </div>
            </div>
          </div>
          <div className="swiper-box fade-up">
            <div className="swiper-container" id="v-space">
              <ul className="swiper-wrapper">
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_01.png" alt="Virtual Spaces" />
                </li>
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_02.png" alt="Virtual Spaces" />
                </li>
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_03.png" alt="Virtual Spaces" />
                </li>
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_04.png" alt="Virtual Spaces" />
                </li>
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_05.png" alt="Virtual Spaces" />
                </li>
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_06.png" alt="Virtual Spaces" />
                </li>
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_07.png" alt="Virtual Spaces" />
                </li>
                <li className="swiper-slide">
                  <img src="./assets/img/v-space_08.png" alt="Virtual Spaces" />
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="v-confer container fade-up">
          <div className="inner clearfix">
            <div className="title">
              <h2 className="main-tit">
                {t("confer.mainTit_01")} <em>{t("confer.mainTit_02")}</em>{" "}
                {t("confer.mainTit_03")}
                <br />
                {t("confer.mainTit_04")}
              </h2>
              <h3 className="sub-txt">
                {t("confer.subTxt_01")}
                <br />
                {t("confer.subTxt_02")}
              </h3>
            </div>
            <div className="v-confer__inner fade-up">
              <div className="v-confer__img">
                <img src="./assets/img/v-conference_01.png" alt="화상 회의" />
              </div>
              <div className="v-confer__img">
                <img src="./assets/img/v-conference_02.png" alt="화상 회의" />
              </div>
            </div>
          </div>
        </section>

        <section className="avatar container">
          <div className="inner">
            <div className="title">
              <h2 className="main-tit fade-up">
                {t("avatar.mainTit_01")}
                <br />
                <em>{t("avatar.mainTit_02")}</em>
                {t("avatar.mainTit_03")}
                <span>
                  {t("avatar.mainTit_04")}&ensp;
                  <em>{t("avatar.mainTit_05")}</em>
                </span>
              </h2>
              <h3 className="sub-txt fade-up">
                {t("avatar.subTxt_01")}
                <br />
                {t("avatar.subTxt_02")}
              </h3>
            </div>
          </div>
          <div className="slider fade-up">
            <div className="slide-box">
              <div className="slide-item first"></div>
              <div className="slide-item first"></div>
              <div className="slide-item first"></div>
              <div className="slide-item first"></div>
            </div>
            <div className="slide-box">
              <div className="slide-item second"></div>
              <div className="slide-item second"></div>
              <div className="slide-item second"></div>
              <div className="slide-item second"></div>
            </div>
            <div className="slide-box">
              <div className="slide-item third"></div>
              <div className="slide-item third"></div>
              <div className="slide-item third"></div>
              <div className="slide-item third"></div>
            </div>
          </div>
        </section>
        <MailForm />
      </main>
    </>
  );
};

export default AlliancePage;
